module.exports = __webpack_public_path__ + "static/media/gc-breakfast-good.d9be1057.png";